import { ActionRuleParams } from '../../types';
import { isIslandPassthroughRequired } from '../../helpers';
import { addIslandPassthrough, deleteIslandPassthrough } from '../../../islands/helpers';

export const requiresPassthrough = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const islands = refMap.islands ?? refMap.kitchen?.design?.islands ?? null;

	if (!islands) return;

	// two passes, so a later island's clear cannot wipe a passthrough added for an earlier one
	// (same pattern as the venting rule). Pass 1 clears island-wide -- not per connection -- so SKU
	// swaps and passthroughs orphaned by a removed connection are both cleaned up.
	islands.children.forEach((island) => deleteIslandPassthrough({ connection: null, refMap, island }));

	// Pass 2 adds each physical connection once, from its source half. `addIslandPassthrough` covers
	// both panels, and only the source half stores the real padding -- `Connection.padding` reports 0
	// on the target half, which would make even a 48" galley gap look adjacent.
	islands.children.forEach((island) => {
		island.connections.children.forEach((connection) => {
			if (connection?.isSource && isIslandPassthroughRequired({ connection, refMap })) {
				addIslandPassthrough({ connection, refMap });
			}
		});
	});
};
